<template>
  <div class="w-full rounded-2xl overflow-hidden shadow-lg">
    <button
      @click="onDropdownClick"
      class="w-full bg-[#FFA500] py-3 px-5 font-bold flex justify-between items-center"
    >
      <span>Plagiarized text found</span>
      <Icon
        :icon="isOpen ? 'ant-design:up-outlined' : 'ant-design:down-outlined'"
        class="text-xl"
      />
    </button>

    <div v-if="isOpen" class="w-full bg-white">
      <div class="w-full p-5 space-y-3 flex flex-col">
        <span>Source of plagiarized text:</span>

        <span class="font-semibold">{{ source }}</span>

        <a class="text-[#1890FFD9] underline" :href="link" target="_blank">{{ link }}</a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Icon } from '@iconify/vue';

export default {
  name: 'PlagiarismCheckerDropdown',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    link: {
      type: String,
      required: true
    },
    source: {
      type: String,
      required: true
    }
  },
  components: {
    Icon
  },
  data() {
    return {
      newItem: false,
      options: [
        'Addition',
        'Follow',
        'Adversativity',
        'Aspect',
        'Temporal',
        'Emphasizing and rephrasing',
        'Consequence',
        'Contrast'
      ]
    };
  },
  methods: {
    onDropdownClick() {
      this.$emit('toggleDropdown');
      this.$emit('card-click');
    },
    onAddItemClick() {
      this.newItem = true;
    },
    onRemoveItemClick() {
      this.newItem = false;
    }
  }
};
</script>
